import icon from "../../../assets/DomeTurret/domeTurret.svg";
import type { ProductGroup } from "../../../types";

export const domeTurret: ProductGroup = {
  id: "domeTurret",
  title: "domeTurret.title",
  icon: {
    src: icon,
    width: 77,
    height: 38,
  },
};
